module.exports = __webpack_public_path__ + "img/26_82.2f8dc96e.png";